import React, { useState, useEffect } from "react";
import { IcanLevels } from './ican-subjects';
import AuthHeader from "../../../UI/AuthHeader/AuthHeader";
import AuthSideMenu from "../../../UI/AuthSideMenu/AuthSideMenu";
import Button from "../../../UI/Buttons/Button";
import { FaLongArrowAltLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { ButtonThin } from "../../../UI/Buttons/Buttons";
import { Modal } from "../../../UI/Modal/Modal";
import useExamStartGate from "../../../../hooks/useExamStartGate";
import ExamReadyModal from "../../ExamReadyModal";
import { setFetching } from "../../../../redux/states";
import Rules from "../../Rules";
import { checkAuthenticatedUser, formatLargeText, startExamSession } from "../../../../utils/client-functions";
import { useErrorSetter } from '../../../../hooks/useUiMessages';
import BubbleFloat from "../../../UI/BubbleFloat/BubbleFloat";

const Ican = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [authMenuOpen, setAuthMenuOpen] = useState(false);
    const [chosenLevel, setChosenLevel] = useState({});
    const [chosenSubject, setChosenSubject] = useState({});
    const [loading, setLoading] = useState(false);
    const [progressStatus, setProgressStatus] = useState('Gathering Exam Details...');
    const [progressPercentage, setProgressPercentage] = useState(0);
    const { examReady, handleOngoing, handleDoneEvent, confirmStartExam, closeGate } = useExamStartGate(navigate, dispatch);

    const isAuth = localStorage?.getItem("token");

    const errorSetter = useErrorSetter();
    useEffect(() => {
        const verifyAuth = async () => {
            try {
                await checkAuthenticatedUser();
            } catch (error) {
                if (typeof errorSetter === 'function') errorSetter("Please login to access mock exams");
                sessionStorage.setItem("prevPath", window.location.pathname);
                if (typeof navigate === 'function') navigate("/popin");
            }
        };
        verifyAuth();
    }, [navigate, errorSetter]);


    const checkIfAuth = async () => {
        try {
            await checkAuthenticatedUser();
        } catch (error) {
            dispatch(setFetching(false));
            errorSetter("Please login to generate an exam");
            sessionStorage.setItem("prevPath", window.location.pathname);
            return navigate("/popin");
        }
    };

    const closeModalsAndReset = () => {
        setChosenSubject({});
    };


    const toggleAuthMenu = () => {
        setAuthMenuOpen(!authMenuOpen);
    };


    const handleStartExam = async () => {
        await checkIfAuth();
        if (Object.keys(chosenSubject).length === 0) {
            errorSetter("Please select a subject to start the exam");
            return;
        }

        setLoading(true);
        setProgressStatus("Gathering Exam Details...");
        setProgressPercentage(5);
        const chosenSubjectWithExamName = {
            timeAlloted: chosenSubject.timeAlloted,
            description: chosenSubject.description,
            subject: chosenSubject.subjectName,
            examName: "ICAN",
            level: chosenLevel.level
        };

        try {
            await startExamSession({
                payload: chosenSubjectWithExamName,
                tokenOverride: isAuth,
                onOngoing: (examDetails) => { setLoading(false); handleOngoing(examDetails); },
                onDone: (e) => { handleDoneEvent(e); },
                onError: (msg) => { setLoading(false); errorSetter(msg); },
                setLoading, setProgressStatus, setProgressPercentage
            });
        } catch (error) {
            setLoading(false);
            errorSetter(error?.response?.data?.message || error?.response?.data?.error || "An Error Occurred. Please try again. If issue persist, please chat with us.");
            if (error?.response?.data?.openPricing) {
                window.dispatchEvent(new CustomEvent('openExamPricing'));
            }
        }
    };




    return (
        <div className="auth-container">
            <BubbleFloat/>

            <div className="auth-container-inner content">
                <AuthHeader
                    authMenuOpen={authMenuOpen}
                    onClick={toggleAuthMenu}
                    headerText="ICAN MOCK"
                />
                <AuthSideMenu opened={authMenuOpen} arrayDetails={[]} onSwitch={() => {}} />
                <div style={{ margin: '12px 0' }}>
                    <Button secondaryLight={true} link='/user/dashboard/mock'>
                        <FaLongArrowAltLeft size='1rem' color='crimson' /> &nbsp;back to exams
                    </Button>
                </div>

                <div className="BodyWrapper">
                    <div className="BuildNavigator">
                        <div className="ActiveNav">
                            <span>1</span>Selection
                        </div>
                        <div> <span>2</span>Simulation </div>
                        <div> <span>3</span>Insights & Tutor </div>
                    </div>

                    <div style={{ padding: '20px 5px' }}>

                        <h4>Select a Level to Start</h4>
                        <div style={{ display: 'flex', justifyContent: 'space-around', paddingLeft: 1, paddingBottom: 1, flexWrap: 'wrap', marginTop: '20px' }}>
                            {IcanLevels.map((level, index) => (
                                <div key={index} style={{ marginBottom: "10px", maxWidth: "12rem", minWidth: "10rem" }}>
                                    <ButtonThin
                                        fontSize='.8rem'
                                        border='1px solid #E5E5EA'
                                        width={'100%'}
                                        height='40px'
                                        color='black'
                                        onClick={() => setChosenLevel(level)}
                                    >
                                        {level.level}
                                    </ButtonThin>
                                </div>
                            ))}
                        </div>

                    </div>

                    {Object.keys(chosenLevel).length > 0 && (
                        <div style={{padding: "20px"}}>
                            <div className={"Segment BubblePopIn"}>
                                <h4>{chosenLevel.level} Details</h4>
                                {chosenLevel.description && (
                                    <div style={{ marginBottom: "1rem", fontSize: ".95rem", color: "#444" }}>
                                        {formatLargeText(chosenLevel.description)}
                                    </div>
                                )}
                                
                                <h4>Select a Subject to Start</h4>
                                <div style={{ display: 'flex', justifyContent: 'space-around', paddingLeft: 1, paddingBottom: 1, flexWrap: 'wrap', marginTop: '20px' }}>
                                    {chosenLevel.subjects && chosenLevel.subjects.map((subject, idx) => (
                                        <div key={idx} style={{ marginBottom: "10px", maxWidth: "12rem", minWidth: "10rem" }}>
                                            <ButtonThin
                                                fontSize='.8rem'
                                                border='1px solid #E5E5EA'
                                                width={'100%'}
                                                height='40px'
                                                color='black'
                                                onClick={() => setChosenSubject(subject)}
                                            >
                                                {subject.subjectName}
                                            </ButtonThin>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                    )}
                </div>

            </div>

            {Object.keys(chosenSubject).length >= 1 && !examReady && (
                <Rules
                    examName={`ICAN ${chosenLevel.level} Mock Exam`}
                    closeModalsAndReset={closeModalsAndReset}
                    subject={chosenSubject}
                    handleStartExam={handleStartExam}
                />
            )}

            {loading && (
                <Modal
                    header4={`PROCESSING... DO NOT RELOAD`}
                    header3={progressStatus}
                    progress={progressPercentage}
                />
            )}
            {examReady && (
                <ExamReadyModal
                    isOpen={examReady}
                    onClose={closeGate}
                    onStart={confirmStartExam}
                    examLabel="ICAN"
                />
            )}
        </div>
    );
};

export default Ican;

